<template>
  <div>
    <iframe
      ref="iframe"
      frameborder="0"
      width="100%"
      credentialless="true"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      :height="height"
      @load="onLoad" />
  </div>
</template>

<script>
export default {
  props: {
    html: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      height: "10px"
    }
  },
  watch: {
    html() {
      this.updateIframeContent()
    }
  },
  mounted() {
    this.updateIframeContent()
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        this.height = `${this.$refs.iframe?.contentWindow?.document?.body?.scrollHeight}px`
      }, 1000)

      this.updateIframeContent()
    },
    updateIframeContent() {
      const iframeDoc = this.$refs.iframe?.contentWindow?.document
      iframeDoc?.open()
      iframeDoc?.write(this.html)
      iframeDoc?.close()
    }
  }
}
</script>
